var _defs, _clipPath, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestimonialsIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    enableBackground: "new 0 0 66 66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 18,
    y: 18,
    width: 30,
    height: 30
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094580677659989728470000010406518683482822567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000094580677659989728470000010406518683482822567_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025416584943244925970000004040099035010352022_",
    gradientUnits: "userSpaceOnUse",
    x1: 33,
    y1: 49.3564,
    x2: 33,
    y2: 20.6068,
    gradientTransform: "matrix(1 0 0 -1 0 68)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE38D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCD38"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000025416584943244925970000004040099035010352022_)",
    d: "M47.9,29.5c-0.2-0.6-0.7-1-1.4-1.1l-8.7-0.8 l-3.4-8c-0.3-0.6-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1l-3.4,8l-8.7,0.8c-0.6,0.1-1.2,0.5-1.4,1.1c-0.2,0.6,0,1.3,0.5,1.7l6.5,5.7 l-1.9,8.5c-0.1,0.6,0.1,1.3,0.6,1.6c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.8-0.2l7.5-4.5l7.5,4.5c0.5,0.3,1.2,0.3,1.8-0.1 c0.5-0.4,0.8-1,0.6-1.6l-1.9-8.5l6.5-5.7C47.9,30.8,48.1,30.1,47.9,29.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialsIcon2);
export default __webpack_public_path__ + "static/media/testimonials-icon-2.6473ef65fe9b0063d46c5650cf339926.svg";
export { ForwardRef as ReactComponent };